import {useState} from 'react';

import {NOT_ARCHIVED_PURPOSE_STRING} from 'archive/ArchiveConstants';
import {LimitOffsetInput} from 'graphql-client/__generated/graphqlGlobalTypes';

export const DEFAULT_LIMIT_OFFSET_INPUT = {
  limit: 10,
  offset: 0,
};

export interface RelevantTemplatesListingCriteria {
  searchTerm: string;
  collectionIds: Array<string>;
}

export const DEFAULT_RELEVANT_TEMPLATES_LISTING_CRITERIA = {
  searchTerm: '',
  collectionIds: [],
};

export interface RelevantTemplatesListingActions {
  onChangeListingCriteria: (updatedListingCriteria: RelevantTemplatesListingCriteria) => void;
  onChangeOffset: (offset: number) => void;
  onChangeSelectedArchivePurposeFilters: (selectedArchivePurposeFilters: Array<string>) => void;
}

export interface RelevantTemplatesListingState {
  listingCriteria: RelevantTemplatesListingCriteria;
  limitOffsetInput: LimitOffsetInput;
  selectedArchivePurposeFilters: Array<string>;
}

/**
 * React hook to track state of RelevantTemplatesListing and cross-state logic.
 */
export function useRelevantTemplatesListing(): [
  RelevantTemplatesListingState,
  RelevantTemplatesListingActions,
] {
  const [listingCriteria, setListingCriteria] = useState<RelevantTemplatesListingCriteria>(
    DEFAULT_RELEVANT_TEMPLATES_LISTING_CRITERIA
  );
  const [limitOffsetInput, setLimitOffsetInput] = useState<LimitOffsetInput>(DEFAULT_LIMIT_OFFSET_INPUT);
  const [selectedArchivePurposeFilters, setSelectedArchivePurposeFilters] = useState<Array<string>>([
    NOT_ARCHIVED_PURPOSE_STRING,
  ]);

  function handleChangeListingCriteria(updatedListingCriteria: RelevantTemplatesListingCriteria): void {
    setListingCriteria(updatedListingCriteria);
    // Reset to first page when criteria changes.
    resetOffset();
  }

  function handleChangeOffset(offset: number): void {
    updateOffset(offset);
  }

  function updateOffset(offset: number): void {
    setLimitOffsetInput((oldLimitOffsetInput) => ({
      ...oldLimitOffsetInput,
      offset,
    }));
  }

  function resetOffset(): void {
    updateOffset(DEFAULT_LIMIT_OFFSET_INPUT.offset);
  }

  return [
    {listingCriteria, limitOffsetInput, selectedArchivePurposeFilters},
    {
      onChangeListingCriteria: handleChangeListingCriteria,
      onChangeOffset: handleChangeOffset,
      onChangeSelectedArchivePurposeFilters: setSelectedArchivePurposeFilters,
    },
  ];
}
